module.exports = __webpack_public_path__ + "static/media/jp_logo_mobile.1509f42b.png";